<template>
  <div class="student-index">
    <Header></Header>
    <div class="index-invite-bg">
      <div class="index-invite max-w">
        <div class="invite-title">输入班级邀请码，加入班级</div>
        <div class="invite-content">
          <div class="invite-input">
            <input type="text" class="invite" placeholder="请输入班级邀请码，加入班级" v-model="classCode" />
            <div class="join-class" @click="searchClass()">加入班级</div>
          </div>
          <div class="join-record" @click="$router.push(`/${school_code}/student/joinrecord`)">
            加入班级记录
          </div>
        </div>
        <img src="../../assets/image/student/index/state.png" width="100%" alt="" />
      </div>
    </div>
    <template>
      <div class="practice-bg" v-if="activityList.length > 0">
        <div class="practice-content max-w">
          <div class="practice-title"></div>
          <div class="practice-list">
            <div class="practice-item" v-for="(item, ind) in activityList" :key="ind">
              <div class="course-state start" v-if="item.status == 1">开课</div>
              <div class="course-state end" v-else-if="item.status == 2">
                结课
              </div>

              <div class="item-img" :style="`background-image: url('${item.cover}')`"></div>
              <div class="item-info">
                <div class="item-title">
                  {{ item.name }}
                </div>
                <div class="item-common">
                  <a-popover class="a-popover" v-if="item.term_name && item.term_name.length > 15" placement="bottom">
                    <template slot="content">
                      <span>实践学期：</span>{{ item.term_name }}
                    </template>
                    <span>实践学期：</span>{{ item.term_name }}
                  </a-popover>
                  <template v-else><span>实践学期：</span>{{ item.term_name }}</template>
                </div>
                <div class="item-common">
                  <a-popover class="a-popover" v-if="item.teacher_names && item.teacher_names.join('、').length > 15" placement="bottom">
                    <template slot="content">
                      <span>负责教师：</span>{{ item.teacher_names.join("、") }}
                    </template>
                    <span>负责教师：</span>{{ item.teacher_names.join("、") }}
                  </a-popover>
                  <template v-else><span>负责教师：</span>{{ item.teacher_names.join("、") }}</template>
                </div>

                <div class="item-common">
                  <a-popover class="a-popover" v-if="item.class_names && item.class_names.join('、').length > 15" placement="bottom">
                    <template slot="content">
                      <div>{{ item.class_names.join('、') }}</div>
                    </template>
                    <span>实践班级：</span>{{ item.class_names.join('、') }}
                  </a-popover>
                  <template v-else> <span>实践班级：</span>{{ item.class_names.join('、') }}</template>
                </div>
                <div class="item-btnls">
                  <div class="btn-item" @click="startPractice(item)" v-if="item.status == 1">
                    开始实践
                  </div>
                  <div class="btn-item" @click="checkGrade(item)">查看成绩</div>
                  <div class="btn-item" @click="toMyClass(item)">我的班级</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="not-content" v-else>
        <img src="../../assets/image/student/index/not-content.png" alt="" />
        <div class="not-text">暂无实践活动，请先加入班级</div>
      </div>
    </template>
    <CommonModal v-model="isJoinClass" title="实践活动" confirmText="加入班级" :showCancel="false" @confirm="joinClass()">
      <div class="join-class">
        <div class="class-title">{{ codeForClassInfo.activity_name }}</div>
        <div class="class-name">班级名称：{{ codeForClassInfo.name }}</div>
        <div class="class-name">
          负责教师：{{ codeForClassInfo.teacher_name }}
        </div>
      </div>
    </CommonModal>
    <CommonModal v-model="isJoinError" title="加入班级失败" confirmText="我知道了" :showCancel="false" @confirm="resetCode()">
      <div class="join-error">
        <div class="error-icon"></div>
        <div class="error-text">{{ errorText }}</div>
      </div>
    </CommonModal>
    <CommonModal v-model="isJoinSuccess" title="加入班级成功" confirmText="我知道了" :showCancel="false" @confirm="getCenterActivity()">
      <div class="join-success">
        <div class="success-icon"></div>
        <div class="success-text">{{ successText }}</div>
      </div>
    </CommonModal>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import "../../assets/css/student.less";
import services from "../../assets/js/services";
import CommonModal from "../../components/CommonModal.vue";
import loading from "../../components/loading.vue";

export default {
  components: {
    Header,
    CommonModal,
    loading,
  },
  data () {
    return {
      services,
      loading: false,
      school_code: localStorage.getItem("schoolCode"),
      activityList: [],
      isJoinClass: false,
      isJoinError: false,
      isJoinSuccess: false,
      classCode: "",
      codeForClassInfo: {},
      errorText: "",
      successText: "",
    };
  },
  mounted () {
    this.getCenterActivity('init');
    let code = this.$route.query.code
    if (code) {
      this.classCode = code
      this.searchClass()
    }
  },
  methods: {
    async getCenterActivity (init) {
      this.isJoinSuccess = false
      this.loading = true;
      let res = await services.getCenterActivity();
      if (res.code == "0000") {
        this.activityList = res.data.items;
      }
      this.loading = false;
      if (!init) this.resetCode()
    },
    resetCode () {
      this.isJoinError = false
      this.classCode = ""
      if (this.$route.query.code) this.$router.push(`/${this.school_code}/student`)
    },
    //邀请码获取班级详情
    async searchClass () {
      this.loading = true;
      if (this.classCode.length > 0) {
        let res = await services.getclassInfoForCode({
          code: this.classCode.trim(),
        });
        if (res.code == "0000") {
          this.codeForClassInfo = res.data;
          this.isJoinClass = true;
        } else {
          this.$message.error(res.message);
        }
      } else {
        this.$message.error("邀请码为空");
      }
      this.loading = false;
    },
    async joinClass () {
      try {
        let res = await services.postJoinClass({
          code: this.codeForClassInfo.code,
        });
        if (res.code == "0000") {
          this.successText = `您已成功加入本场实践活动【${this.codeForClassInfo.activity_name}】、实践班级【${this.codeForClassInfo.name}】。`
          this.isJoinClass = false;
          // this.successText = res.message;
          this.isJoinSuccess = true;

        } else {
          this.isJoinClass = false;
          this.errorText = res.message;
          this.isJoinError = true;
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    //我的班级
    toMyClass (item) {
      this.$router.push({
        path: `/${this.school_code}/student/myClass`,
        query: {
          classes: item.class_id,
          activity_id: item.id,
        },
      });
    },
    //查看成绩
    checkGrade (item) {
      this.$router.push({
        path: `/${this.school_code}/student/grade`,
        query: {
          activity_id: item.id,
        },
      });
    },
    //开始实践
    startPractice (item) {
      let isOpen = localStorage.getItem("menuOpen")
      if (!isOpen) {
        localStorage.setItem("menuOpen", "1") // 1开启 2关闭
      }
      this.$router.push({
        path: `/${this.school_code}/student/experiment`,
        query: {
          activity_id: item.id,
          course_id: item.course_id,
        },
      });
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.student-index {
    .index-invite-bg {
        background-image: url('../../assets/image/student/index/invite-bg.png');
        background-size: cover;
        background-position: top center;
        padding-bottom: 37px;
        .index-invite {
            padding-top: 110px;
            margin: 0 auto;
            // max-width: 1600px;
            .invite-title {
                font-weight: bold;
                font-size: 18px;
                color: #302e2f;
                text-align: center;
                // line-height: 80px;
            }
            .invite-content {
                margin-top: 46px;
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
                position: relative;
                &::before {
                    content: '';
                    width: 950px;
                    height: 200px;
                    display: block;
                    position: absolute;
                    background-image: url('../../assets/image/student/index/invite-input-icon.png');
                    background-size: cover;
                    bottom: 0;
                }
                .invite-input {
                    width: 815px;
                    height: 42px;
                    background: #ffffff;
                    border-radius: 21px;
                    border: 1px solid #dbdad8;
                    margin-right: 10px;
                    display: flex;
                    position: relative;
                    z-index: 1;
                    .invite {
                        border: none;
                        outline: none;
                        height: 100%;
                        border-radius: 21px;
                        flex: 1;
                        padding-left: 18px;
                        line-height: 40px;
                        font-size: 14px;
                        &::placeholder {
                            font-weight: 400;
                            font-size: 14px;
                            color: #8d8e91;
                        }
                    }
                    .join-class {
                        width: 92px;
                        height: 100%;
                        background: #a82822;
                        border-radius: 0px 21px 21px 0px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #ffffff;
                        text-align: center;
                        line-height: 40px;
                        cursor: pointer;
                    }
                }
                .join-record {
                    width: 124px;
                    height: 42px;
                    background: #fff3f2;
                    border-radius: 21px;
                    border: 1px solid #cc9d9a;
                    font-weight: 400;
                    font-size: 14px;
                    margin-left: 10px;
                    color: #a82822;
                    line-height: 40px;
                    text-align: center;
                    cursor: pointer;
                    position: relative;
                    z-index: 1;
                }
            }
        }
    }
    .practice-bg {
        background-image: url('../../assets/image/student/index/practice-bg.png');
        background-size: cover;
        background-position: center;
        min-height: calc(100vh - 540px);
        .practice-content {
            padding-top: 37px;
            // max-width: 1600px;
            margin: 0 auto;
            .practice-title {
                margin: 0 auto;
                width: 433px;
                height: 30px;
                background-image: url('../../assets/image/student/index/practice-title.png');
                background-size: cover;
                background-position: center;
            }
            .practice-list {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-top: 28px;
                .practice-item {
                    width: calc(50% - 20px);
                    height: 230px;
                    background: linear-gradient(
                        0deg,
                        #ffffff 0%,
                        #ffffff 82%,
                        #fff1f1 100%
                    );
                    border-radius: 4px;
                    border: 1px solid #f1e6d7;
                    display: flex;
                    margin-bottom: 20px;
                    position: relative;
                    .course-state {
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        width: 50px;
                        height: 26px;
                        border-radius: 0px 0px 12px 0px;
                        border: 1px solid #ffffff;
                        font-family: YouSheBiaoTiHei;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 24px;
                        text-align: center;
                        color: #ffffff;

                        &.start {
                            background: #3f82f2;
                        }
                        &.end {
                            background: #7f8892;
                        }
                    }
                    .item-img {
                        height: 100%;
                        width: 230px;
                        background-image: url('../../assets/image/student/index/xg-bg.png');
                        background-size: cover;
                        background-position: top center;
                        flex-shrink: 0;
                    }
                    .item-info {
                        flex: 1;
                        padding-top: 18px;
                        padding-left: 38px;
                        padding-right: 60px;
                        overflow: hidden;
                        .item-title {
                            font-weight: bold;
                            font-size: 17px;
                            color: #333132;
                            line-height: 24px;
                            height: 48px;
                            overflow: hidden;
                            display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
                            -webkit-line-clamp: 2; /* 行数，值可以改，表示展示X行后多余的缩略展示 */
                            -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
                            word-break: break-all;
                            margin-bottom: 18px;
                        }
                        .item-common {
                            font-weight: 400;
                            font-size: 14px;
                            color: #45464b;
                            line-height: 26px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            span:not(.a-popover) {
                                color: #8b97ac;
                            }
                        }
                        .item-btnls {
                            display: flex;
                            margin-top: 14px;
                            .btn-item {
                                width: 88px;
                                height: 32px;
                                background: #fff3f2;
                                border-radius: 16px;
                                border: 1px solid #cc9d9a;
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 30px;
                                color: #a82822;
                                text-align: center;
                                margin-right: 10px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }
    .not-content {
        display: flex;
        flex-direction: column;
        padding: 50px 0;

        img {
            width: 300px;
            margin: 0 auto;
        }
        .not-text {
            text-align: center;
            margin-top: 20px;
            font-weight: 400;
            font-size: 16Fpx;
            color: #a6a4a3;
        }
    }
}
.join-class {
    .class-title {
        padding: 16px 26px;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #373536;
        line-height: 18px;
        background: #fff7e9;
        margin-bottom: 16px;
    }
    .class-name {
        font-size: 14px;
        color: #373536;
        line-height: 18px;
        text-align: center;
        margin-bottom: 16px;
    }
    width: 350px;
    // height: 64px;
}
.join-error {
    width: 330px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .error-icon {
        width: 122px;
        height: 76px;
        background-image: url('../../assets/image/student/index/join-error.png');
        background-size: cover;
        background-position: center;
        margin-bottom: 23px;
    }
    .error-text {
        font-size: 14px;
        color: #373536;
        line-height: 24px;
        text-align: center;
    }
}
.join-success {
    width: 330px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .success-icon {
        width: 122px;
        height: 76px;
        background-image: url('../../assets/image/student/index/join-success.png');
        background-size: cover;
        background-position: center;
        margin-bottom: 23px;
    }
    .success-text {
        font-size: 14px;
        color: #373536;
        line-height: 24px;
        text-align: center;
    }
}
</style>